// Agent Detail Mock Data
export const agentDetailsMock = {
  "agent-1": {
    id: "agent-1",
    name: "Customer Support Bot",
    description: "Handles basic customer inquiries and troubleshooting, supporting our retail experience with automated responses to common questions.",
    status: "ACTIVE",
    channel: "WEB",
    lastActive: new Date(Date.now() - 1200000).toISOString(),
    greeting: "Hello! I'm your Digital Assistant. How can I help you today with your shopping, assembly, or return questions?",
    fallbackMessage: "I'm sorry, I don't have the information to answer that question. Would you like to speak with a human associate?",
    policySetId: "policy-set-1",
    allowedSkills: ["skill-1", "skill-3", "skill-9"],
    icon: "chat-bubble",
    metrics: {
      conversations: 1248,
      avgRating: 4.7,
      successRate: 92.3,
      averageResponseTime: 2.3,
      satisfactionScore: 88.5
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: true,
        maxAttachmentSize: 5,
        enableAudioMessages: true,
        position: "bottom-right",
        theme: "light"
      },
      kioskConfig: {
        fullScreen: true,
        idleTimeout: 300,
        requireAuthentication: false,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-1",
        speed: 1.0,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-1";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-09-15T10:30:45Z",
    updatedAt: "2024-02-20T14:22:18Z"
  },
  
  "agent-2": {
    id: "agent-2",
    name: "Product Recommendation Agent",
    description: "Suggests personalized products based on customer preferences and purchase history",
    status: "ACTIVE",
    channel: "KIOSK",
    lastActive: new Date(Date.now() - 3600000).toISOString(),
    greeting: "Welcome to our store! I can help you find the perfect products for your home. What are you looking for today?",
    fallbackMessage: "I'm not sure I understood what you're looking for. Could you tell me more about what you need?",
    policySetId: "policy-set-2",
    allowedSkills: ["skill-2", "skill-6"],
    icon: "shopping-cart",
    metrics: {
      conversations: 953,
      avgRating: 4.5,
      successRate: 88.7,
      averageResponseTime: 3.1,
      satisfactionScore: 85.2
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: false,
        maxAttachmentSize: 0,
        enableAudioMessages: false,
        position: "bottom-right",
        theme: "light"
      },
      kioskConfig: {
        fullScreen: true,
        idleTimeout: 240,
        requireAuthentication: false,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-2",
        speed: 1.0,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-2";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-10-20T11:45:30Z",
    updatedAt: "2024-02-15T09:18:42Z"
  },
  
  "agent-3": {
    id: "agent-3",
    name: "Return Processing Assistant",
    description: "Guides customers through return and exchange procedures",
    status: "ACTIVE",
    channel: "WEB",
    lastActive: new Date(Date.now() - 7200000).toISOString(),
    greeting: "Hello! I'm your Return Processing Assistant. How can I help you with returns or exchanges today?",
    fallbackMessage: "I'm not able to process that request. Would you like me to connect you with a human representative?",
    policySetId: "policy-set-1",
    allowedSkills: ["skill-3", "skill-4", "skill-7"],
    icon: "box-return",
    metrics: {
      conversations: 721,
      avgRating: 4.2,
      successRate: 91.5,
      averageResponseTime: 2.8,
      satisfactionScore: 83.7
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: true,
        maxAttachmentSize: 10,
        enableAudioMessages: false,
        position: "bottom-right",
        theme: "light"
      },
      kioskConfig: {
        fullScreen: false,
        idleTimeout: 180,
        requireAuthentication: true,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-1",
        speed: 1.0,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-3";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-11-05T09:15:30Z",
    updatedAt: "2024-01-22T13:42:18Z"
  },
  
  "agent-4": {
    id: "agent-4",
    name: "Inventory Checker",
    description: "Helps customers check product availability across locations",
    status: "ACTIVE",
    channel: "KIOSK",
    lastActive: new Date(Date.now() - 10800000).toISOString(),
    greeting: "Hi there! I can help you find the availability of any product in our stores. What are you looking for?",
    fallbackMessage: "I couldn't find that information. Would you like to try a different product or check with a store associate?",
    policySetId: "policy-set-2",
    allowedSkills: ["skill-5", "skill-6"],
    icon: "search",
    metrics: {
      conversations: 1082,
      avgRating: 4.8,
      successRate: 97.2,
      averageResponseTime: 1.9,
      satisfactionScore: 92.1
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: false,
        maxAttachmentSize: 0,
        enableAudioMessages: true,
        position: "bottom-right",
        theme: "dark"
      },
      kioskConfig: {
        fullScreen: true,
        idleTimeout: 120,
        requireAuthentication: false,
        printerEnabled: false
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-2",
        speed: 1.1,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-4";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-12-12T14:30:15Z",
    updatedAt: "2024-02-01T10:18:42Z"
  },
  
  "agent-5": {
    id: "agent-5",
    name: "Order Status Tracker",
    description: "Provides real-time updates on customer orders",
    status: "ACTIVE",
    channel: "WEB",
    lastActive: new Date(Date.now() - 14400000).toISOString(),
    greeting: "Hello! I can help you track your order status. Do you have your order number handy?",
    fallbackMessage: "I'm unable to locate that order information. Would you like to speak with our customer service team?",
    policySetId: "policy-set-3",
    allowedSkills: ["skill-8", "skill-9"],
    icon: "package",
    metrics: {
      conversations: 1567,
      avgRating: 4.6,
      successRate: 94.8,
      averageResponseTime: 2.1,
      satisfactionScore: 89.3
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: false,
        maxAttachmentSize: 0,
        enableAudioMessages: false,
        position: "bottom-left",
        theme: "system"
      },
      kioskConfig: {
        fullScreen: false,
        idleTimeout: 300,
        requireAuthentication: true,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-1",
        speed: 1.0,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-5";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2024-01-10T08:45:22Z",
    updatedAt: "2024-02-18T16:32:10Z"
  },
  
  "agent-6": {
    id: "agent-6",
    name: "Assembly Helper",
    description: "Assists customers with product assembly instructions",
    status: "ACTIVE",
    channel: "KIOSK",
    lastActive: new Date(Date.now() - 21600000).toISOString(),
    greeting: "Hello! I can help you assemble your new purchase. What product are you working on?",
    fallbackMessage: "I don't have assembly instructions for that product. Would you like to check the manufacturer's website or speak to a specialist?",
    policySetId: "policy-set-2",
    allowedSkills: ["skill-1", "skill-10"],
    icon: "tool",
    metrics: {
      conversations: 642,
      avgRating: 4.3,
      successRate: 86.9,
      averageResponseTime: 3.5,
      satisfactionScore: 82.4
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: true,
        maxAttachmentSize: 15,
        enableAudioMessages: false,
        position: "bottom-right",
        theme: "light"
      },
      kioskConfig: {
        fullScreen: false,
        idleTimeout: 600,
        requireAuthentication: false,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "standard-1",
        speed: 0.9,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-6";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-10-30T11:20:45Z",
    updatedAt: "2024-01-28T09:15:30Z"
  },
  
  "agent-7": {
    id: "agent-7",
    name: "Sustainability Advisor",
    description: "Educates customers about sustainable products and practices",
    status: "ACTIVE",
    channel: "WEB",
    lastActive: new Date(Date.now() - 28800000).toISOString(),
    greeting: "Hi! I'm here to help you learn about our sustainable products and eco-friendly initiatives. What would you like to know?",
    fallbackMessage: "I don't have that specific sustainability information. Would you like me to connect you with our sustainability team?",
    policySetId: "policy-set-1",
    allowedSkills: ["skill-11", "skill-12"],
    icon: "leaf",
    metrics: {
      conversations: 498,
      avgRating: 4.4,
      successRate: 89.5,
      averageResponseTime: 2.7,
      satisfactionScore: 86.8
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: false,
        maxAttachmentSize: 0,
        enableAudioMessages: true,
        position: "top-right",
        theme: "light"
      },
      kioskConfig: {
        fullScreen: false,
        idleTimeout: 240,
        requireAuthentication: false,
        printerEnabled: false
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-2",
        speed: 1.0,
        pitch: 1.1
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-7";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2023-12-05T13:40:22Z",
    updatedAt: "2024-02-10T11:28:15Z"
  },
  
  "agent-8": {
    id: "agent-8",
    name: "Delivery Scheduler",
    description: "Helps customers schedule and manage deliveries",
    status: "ACTIVE",
    channel: "KIOSK",
    lastActive: new Date(Date.now() - 36000000).toISOString(),
    greeting: "Hello! I can help you schedule or manage your delivery. What would you like to do today?",
    fallbackMessage: "I'm sorry, I can't process that request. Would you like to speak with our delivery team directly?",
    policySetId: "policy-set-3",
    allowedSkills: ["skill-13", "skill-14"],
    icon: "truck",
    metrics: {
      conversations: 873,
      avgRating: 4.1,
      successRate: 92.7,
      averageResponseTime: 2.4,
      satisfactionScore: 84.2
    },
    deploymentConfig: JSON.stringify({
      webConfig: {
        allowAttachments: false,
        maxAttachmentSize: 0,
        enableAudioMessages: false,
        position: "bottom-right",
        theme: "dark"
      },
      kioskConfig: {
        fullScreen: true,
        idleTimeout: 180,
        requireAuthentication: true,
        printerEnabled: true
      },
      voiceConfig: {
        language: "en-US",
        voice: "neural-1",
        speed: 1.0,
        pitch: 1.0
      }
    }),
    embedCode: `<script>
  (function(w, d, s, o) {
    w.AgentWidget = o;
    var js = d.createElement(s);
    js.src = "https://agent-cdn.example.com/loader.js";
    js.async = 1;
    js.dataset.agentId = "agent-8";
    js.dataset.env = "production";
    d.head.appendChild(js);
  })(window, document, "script", "chatAgent");
</script>`,
    createdAt: "2024-01-15T10:10:45Z",
    updatedAt: "2024-02-22T15:45:30Z"
  }
};